module.exports = __webpack_public_path__ + "static/media/1.0b0e6f09.png";